import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import { colors } from '../../../constants'
import { mediaQuery, mediaQueryForBigger } from '../../utils'

export const NavBarHeight = '60px'
export const LogoWidth = '135.16px'

export const LinkLogo = styled(Link)`
    position: relative;
    text-decoration: none;
`

export const BetaRibbon = styled.div`
    color: ${colors.bluedark};
    font-size: 12px;
    font-weight: bold;
    position: absolute;
    top: 100%;
    right: 8px;
`

export const NavBar = styled.nav`
    background: ${colors.bluelight};
    // box-shadow: 0px 1px 4px 0px #0000004d;
    color: ${colors.white};
    font-size: 15px;
    height: ${NavBarHeight};
    width: 100%;
    top: 0;
    position: relative;
    z-index: 500;
`

export const LinkStyled = styled(Link)`
    display: block;
    padding: 0 20px;
    position: relative;
    text-decoration: none;
    li:hover > & {
        color: ${colors.white};
    }
`

export const MenuItem = styled.li`
    display: inline-block;
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;

    &:hover {
        color: ${colors.white};
        background: ${colors.bluelighter};
    }

    &:hover > ul {
        transform: scaleY(1);
    }

    & a {
        color: ${colors.greylighter};
    }

    ${({ nofit }) => !nofit && 'width: 160px;'}
    ${({ right }) => right && 'float: right;'}
  ${({ nopadding }) => nopadding && 'padding: 0;'}
  ${({ selected }) =>
        selected &&
        `
      background: ${colors.bluedarkest};
      // box-shadow: inset 0px -3px ${colors.orange};
    `}
  
  ${mediaQuery.lg(
        `
      display: block;
      text-align: left;
      width: 100%;
      font-weight: bold;
    `
    )}

  ${({ isSubmenu }) => isSubmenu && mediaQuery.lg(
        `
      padding-left: 20px;
      font-weight: normal;
    `
    )}
`

export const ProfileMenu = styled.button`
    background: transparent;
    border: 0;
    color: ${colors.white};
    display: inline-block;
    float: right;
    height: ${NavBarHeight};
    line-height: ${NavBarHeight};
    outline: none;
    padding: 0;
    text-align: center;
    text-overflow: ellipsis;
    vertical-align: middle;
    white-space: nowrap;

    &:hover {
        color: ${colors.white};
        background: ${colors.bluelighter};
    }

    &:hover > ul {
        transform: scaleY(1);
    }

    & a {
        color: ${colors.greylighter};
    }
`

MenuItem.propTypes = {
    selected: PropTypes.bool,
}

MenuItem.defaultProps = {
    selected: false,
}

export const MenuButton = styled.button`
    background: transparent;
    border: 0;
    color: ${colors.white};
    font-size: 25px;
    height: ${NavBarHeight};
    outline: none;
    padding: 4px 0 0 2px;
    width: ${NavBarHeight};

    ${({ isMobileMenuOpen }) =>
        isMobileMenuOpen
            ? `+ ul {
        transform: scaleY(1);
      }`
            : `+ ul {
        transform: scaleY(0);
      }`}
`

export const MenuBackground = styled.div`
    position: fixed;
    height: 100%;
    width: 100%;
    z-index: 99;
`

export const MenuLabel = styled.span`
    margin-left: 10px;
`

export const Logo = styled.img`
    height: 100%;
`

export const Menu = styled.ul`
    color: ${colors.greylighter};
    cursor: pointer;
    display: inline-block;
    line-height: ${NavBarHeight};
    margin: 0;
    overflow: hidden;
    padding: 0;
    vertical-align: middle;
    z-index: 100;

    ${mediaQuery.lg(
        `
      background: inherit;
      left: 0;
      position: fixed;
      right: 0;
      top: ${NavBarHeight};

      transform: scaleY(0);
      transform-origin: top;
      transition: all 0.3s ease-in-out;
    `
    )}

    ${mediaQueryForBigger.md(
        `
      float: right;
    `
    )}
`

export const Submenu = styled.ul`
    // box-shadow: 0px 3px 3px -2px #0000004d;
    width: 160px;
    padding: 0;
    position: absolute;
    transform: scaleY(0);
    transform-origin: top;
    transition: all 0.3s ease-in-out;

    ${mediaQuery.mobile(`
    width: 100%;
  `)}
`

export const SubmenuItem = styled.li`
    background: ${colors.bluelight};
    display: block;
    overflow: hidden;
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;

    &:hover {
        color: ${colors.white};
        background: ${colors.bluelighter};

        & a {
            color: ${colors.white};
        }
    }

    ${({ selected }) =>
        selected &&
        `
      background: ${colors.bluelighter2};
    `}
`

export const NoLinkStyled = styled.div`
    padding: 0 20px;
    position: relative;
`

export const UploadButton = styled.div`
    background: transparent;
    border: 0;
    color: ${colors.white};
    display: inline-block;
    float: right;
    height: ${NavBarHeight};
    line-height: ${NavBarHeight};
    outline: none;
    padding: 0;
    text-align: center;
    text-overflow: ellipsis;
    vertical-align: middle;
    white-space: nowrap;

    &:hover > ul {
        transform: scaleY(1);
    }

    & a {
        color: ${colors.greylighter};
    }
`

export const Icon = styled(FontAwesomeIcon)``

export const Img = styled.img`
    width: 20px;
`   
